import { DeleteOutlined, EllipsisOutlined } from '@ant-design/icons'
import { Button, Dropdown, Menu, Tooltip } from 'antd'
import { getOperationName } from 'apollo-link'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { GetViewerCreatedGroupsDocument, useGroupUnArchiveMutation } from '@/generated/graphql'

export interface UnArchiveGroupProps {
  groupId: number
}

export const UnArchiveGroup: React.FC<UnArchiveGroupProps> = ({ groupId }) => {
  const [t] = useTranslation()

  const [unArchiveGroup] = useGroupUnArchiveMutation({
    variables: {
      groupId: groupId,
    },
    refetchQueries: [getOperationName(GetViewerCreatedGroupsDocument)!],
  })

  const dropdownMenu = (
    <Menu>
      <Menu.Item onClick={() => unArchiveGroup()}>
        <Tooltip title={t('groups.unArchiveTooltip')}>
          <span>
            <DeleteOutlined /> {t('groups.unArchive')}
          </span>
        </Tooltip>
      </Menu.Item>
    </Menu>
  )

  return (
    <Dropdown trigger={['click']} overlay={dropdownMenu}>
      <Button shape='circle' icon={<EllipsisOutlined />} style={{ padding: 0, border: 0 }} />
    </Dropdown>
  )
}
